import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';//Link, 
//import { connect } from 'react-redux';
//import { alertSuccess } from '../actions/alertActions';
//import { api } from '../services/rest';
//import { config } from '../config';
import {  setInterval } from 'timers';//setTimeout,
import HotAirBalloon from '../assets/HotAirBalloon.webp';
import Marshmallows from '../assets/Marshmallow.webp';
import Pizza from '../assets/Pizza.webp';
import Welding from '../assets/Welding.webp';

class BuildPreview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            buildCompleted: false,
            index: 0,
            images: [
                { src: Welding },                
                { src: Marshmallows },
                { src: HotAirBalloon },
                { src: Pizza }                
            ],
            timeTaken:0
        }
        //this.timer = this.timer.bind(this);
        this.incrementIndex = this.incrementIndex.bind(this);
    }

    componentDidMount() {
        this.interval = setInterval(this.onTick, 4000);
    }

    onTick = () => {
        var currentIndex = this.state.index;
        var nextIndex = this.incrementIndex(currentIndex);        
        this.setState({ index: nextIndex, timeTaken: this.state.timeTaken + 4 });
    }

    incrementIndex(currentIndex) {
        var nextIndex = currentIndex + 1;
        if (nextIndex < this.state.images.length) return nextIndex;
        else return 0
    }

    componentWillUnmount() {
        // Remove this to see warning.
        clearInterval(this.interval._id);
    }

    render() {
        var image = this.state.images[this.state.index];
        const redirect = <Redirect to={`/${this.props.client}/${this.props.project}/Preview`} />
        let imageStyle = {
            width: '100%',
            height: '100vh',
            position: 'fixed',
            top: '40px'
        }

        let headerStyle = {
            width: '100%',
            position: 'fixed',
            top: '40px',
            color: '#fff'
        }
        const BuildTimeWarning = <>
            {(this.state.timeTaken > 300)? <h4>If you are seeing this message for longer than 5 minutes then there has been a disconnect between Blaze and your hosting.<br /> Your site should have completed publishing but to confirm this please press your Browsers back button and Publish again.</h4> : ""}
        </>
        //console.log(this.state.buildCompleted);
        if (!this.state.buildCompleted) {
            return (
                <div>
                    
                    <img alt="" style={imageStyle} src={image.src} />
                    <div style={headerStyle} className="text-center">
                        <h1>We are getting your site ready. </h1>
                        <h2>This may take a few moments. <br />Please do not refresh your browser.</h2> 
                        {BuildTimeWarning}
                    </div>
                    
                </div>
            )
        }
        else {
            return redirect;
        }
    }
}

export default BuildPreview

